export const Z_INDEX_ALERT = 1400;
export const Z_INDEX_VEHICLE = 140;
export const Z_INDEX_VEHICLE_LABEL = 120;
export const Z_INDEX_MAP_MARKER = 100;
